import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "__designMode"];
import * as React from 'react';
/**
 * 文字 字体、大小、行高
 * @param props
 */
var Link = function Link(props, ref) {
  var children = props.children,
    __designMode = props.__designMode,
    others = _objectWithoutPropertiesLoose(props, _excluded);
  var otherProps = {};
  if (__designMode === 'design') {
    otherProps.onClick = function (e) {
      e.preventDefault();
    };
  }
  return /*#__PURE__*/React.createElement("a", _extends({}, others, {
    ref: ref
  }, otherProps), children);
};
var RefLink = /*#__PURE__*/React.forwardRef(Link);
RefLink.defaultProps = {
  href: 'https://fusion.design',
  children: '这是一个超链接',
  target: '_blank'
};
export default RefLink;